// extracted by mini-css-extract-plugin
module.exports = {"contactSection":"ContactSection_contactSection__2UPAz"};